import React from 'react'

import { ListPlainTextCell } from 'lib/components'
import { ITransformedRESTServiceEndpointAttributeCharacterizationReport } from 'domains/characterizations/models/ITransformedRESTCharacterizationReport'
import IRestCModel from 'domains/modeling/models/IRestCModel'
import {
  findModelServiceEndointAttributeByName,
  findSpecServiceEndointAttributeByName,
} from 'domains/modeling/utils/restCOR1p1utils'
import IRestCSpec from 'domains/specifications/models/IRestCSpec'
import { OR_1P1_REST_ROSTERING_CONSUMER_SERVICES } from 'domains/modeling/constants/restCOneRoster1p1'
import { FORMAT_TO_DISPLAY } from 'domains/characterizations/models/CharacterizationReport'

interface IProps
  extends ITransformedRESTServiceEndpointAttributeCharacterizationReport {
  serviceName: string
  endpointName: string
  specification: IRestCSpec
  model?: IRestCModel
}

export default function RESTCharacterizationAttributeFormatCell(props: IProps) {
  const {
    endpointName,
    serviceName,
    attributeName,
    model,
    dataType,
    specification,
  } = props
  let display = dataType
  if (!display && model) {
    const modelAttribute = findModelServiceEndointAttributeByName(
      model,
      serviceName as OR_1P1_REST_ROSTERING_CONSUMER_SERVICES,
      endpointName,
      attributeName,
    )
    display = modelAttribute ? modelAttribute.dataType : null
  }
  if (!display) {
    const specAttribute = findSpecServiceEndointAttributeByName(
      specification,
      serviceName as OR_1P1_REST_ROSTERING_CONSUMER_SERVICES,
      endpointName,
      attributeName,
    )
    display = specAttribute ? specAttribute.dataType : ''
  }

  return (
    <ListPlainTextCell wordBreak="break-word">
      {display ? FORMAT_TO_DISPLAY[display] : null}
    </ListPlainTextCell>
  )
}
